import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { LcsCallStatePipeModule } from '@lcs/shared/call-state-pipe';
import { LcsLoadingOverlayModule } from '@lcs/shared/loading-overlay';
import { SharedReportsModule } from '@ndt/reports/shared/shared-reports.module';
import { TileWrapperModule } from 'src/app/pages/tiles/containers/tile-wrapper/tile-wrapper.module';
import { TileLayoutConfigurationsModule } from '../../../tile-layout-configurations/tile-layout-configurations.module';
import { AddDashboardTileFormComponent } from './add-dashboard-tile-form.component';

@NgModule({
   declarations: [AddDashboardTileFormComponent],
   exports: [AddDashboardTileFormComponent],
   imports: [
      CommonModule,
      MatButtonModule,
      ReactiveFormsModule,
      TileLayoutConfigurationsModule,
      SharedReportsModule,
      TileWrapperModule,
      LcsCallStatePipeModule,
      LcsLoadingOverlayModule,
   ],
})
export class AddDashboardTileFormModule {}
